import { format, isValid, parseISO } from 'date-fns'

export function parseNextAvailableDate(dateStr: string): Date | null {
  const parsed = parseISO(dateStr)
  if (isValid(parsed)) {
    const date = new Date(parsed)
    date.setHours(0, 0, 0, 0)
    return date
  }

  const fallback = new Date(`${dateStr}T12:00:00`)
  if (isValid(fallback)) {
    fallback.setHours(0, 0, 0, 0)
    return fallback
  }

  return null
}

export function isDateInBookingCalendar(date: Date, dates: Date[]): boolean {
  const dateKey = format(date, 'yyyy-MM-dd')
  return dates.some((day) => format(day, 'yyyy-MM-dd') === dateKey)
}

export function isLastVisibleCalendarDay(selectedDate: Date | null | undefined, dates: Date[]): boolean {
  const lastDay = dates[dates.length - 1]
  if (!selectedDate || !lastDay) {
    return false
  }

  return format(selectedDate, 'yyyy-MM-dd') === format(lastDay, 'yyyy-MM-dd')
}

export function shouldShowNextAvailableButton(options: {
  noslot: boolean
  nextAvailableDate: string | null
  selectedDate: Date | null | undefined
  dates: Date[]
}): boolean {
  const { noslot, nextAvailableDate, selectedDate, dates } = options

  if (isLastVisibleCalendarDay(selectedDate, dates)) {
    return false
  }

  const nextDate = nextAvailableDate ? parseNextAvailableDate(nextAvailableDate) : null
  if (!nextDate || !isDateInBookingCalendar(nextDate, dates)) {
    return false
  }

  return noslot && !!nextAvailableDate && !!selectedDate && format(selectedDate, 'yyyy-MM-dd') !== nextAvailableDate
}

export function shouldShowContinueButton(showNextAvailableButton: boolean, noslot: boolean): boolean {
  return !showNextAvailableButton && !noslot
}
